import { useEffect } from 'react';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import TopBar from '../components/TopBar';
import PageTitle from '../components/PageTitle';
import SiteFooter from '../components/SiteFooter';

export default function Terms() {
  const { t } = useTranslation('common');

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <div className="min-h-screen flex flex-col bg-background">
      <PageTitle titleKey="terms.title" namespace="common" />
      <TopBar />

      <div className="flex-1 max-w-3xl mx-auto w-full px-4 sm:px-6 lg:px-8 pt-24 pb-16">
        <div className="rounded-2xl border border-border bg-card p-8 sm:p-12 shadow-sm">
          <h1 className="text-3xl font-bold text-foreground tracking-tighter mb-6">{t('terms.title')}</h1>

          <div className="prose prose-neutral dark:prose-invert max-w-none space-y-6 text-sm leading-relaxed text-muted-foreground">
            <p>{t('terms.intro')}</p>

            <h2 className="text-lg font-semibold text-foreground mt-8">{t('terms.section1Title')}</h2>
            <p>{t('terms.section1Content')}</p>

            <h2 className="text-lg font-semibold text-foreground mt-8">{t('terms.section2Title')}</h2>
            <p>{t('terms.section2Content1')}</p>
            <p>{t('terms.section2Content2')}</p>

            <h2 className="text-lg font-semibold text-foreground mt-8">{t('terms.section3Title')}</h2>
            <p>{t('terms.section3Content1')}</p>
            <p>{t('terms.section3Content2')}</p>

            <h2 className="text-lg font-semibold text-foreground mt-8">{t('terms.section4Title')}</h2>
            <p>{t('terms.section4Intro')}</p>
            <ul className="list-disc pl-6 space-y-1">
              <li>{t('terms.section4Item1')}</li>
              <li>{t('terms.section4Item2')}</li>
              <li>{t('terms.section4Item3')}</li>
              <li>{t('terms.section4Item4')}</li>
            </ul>

            <h2 className="text-lg font-semibold text-foreground mt-8">{t('terms.section5Title')}</h2>
            <p>{t('terms.section5Content')}</p>

            <h2 className="text-lg font-semibold text-foreground mt-8">{t('terms.section6Title')}</h2>
            <p>{t('terms.section6Content')}</p>

            <h2 className="text-lg font-semibold text-foreground mt-8">{t('terms.section7Title')}</h2>
            <p>{t('terms.section7Content')}</p>

            <h2 className="text-lg font-semibold text-foreground mt-8">{t('terms.section8Title')}</h2>
            <p>{t('terms.section8Content')}</p>

            <h2 className="text-lg font-semibold text-foreground mt-8">{t('terms.section9Title')}</h2>
            <p>{t('terms.section9Content')}</p>
          </div>

          <div className="flex gap-4 mt-10 pt-6 border-t border-border">
            <Link to="/" className="text-sm font-medium text-primary hover:text-primary/80 transition-colors">
              {t('terms.backToHome')}
            </Link>
          </div>
        </div>
      </div>

      <SiteFooter />
    </div>
  );
}
